// the theme accordion fixes its open height when toggled; call this after
// showing/hiding content inside one so the panel grows/shrinks to fit
function syncCartAccordionHeight(el){
    const accordion = el.querySelector('custom-accordion') || el.closest('custom-accordion');
    if(accordion && accordion.getAttribute('data-open') == 'true' && typeof accordion.setAccordionTextHeight == 'function'){
        accordion.setAccordionTextHeight(true);
    }
}

if(!customElements.get('cart-note')){
    class CartNote extends HTMLElement {
        constructor(){
            super();
        }

        connectedCallback(){
            this.textarea = this.querySelector('textarea');
            this.status = this.querySelector('.sidebar__cart-note-status');
            if(this.textarea){
                this.textarea.addEventListener('change', this.saveNote.bind(this));
            }
        }

        saveNote(){
            const cartHost = this.closest('cart-drawer');
            const config = fetchConfig();
            const note = this.textarea.value;
            config.body = JSON.stringify({ note: note });
            if(cartHost) config.signal = cartHost.requestSignal();

            // Keep saves in order and finish them before a cart refresh replaces
            // the note field. Checkout also submits its current value directly.
            const save = async () => {
                const response = await fetch(routes.cart_update_url, config);
                if(!response.ok) throw new Error('Unable to save the cart note.');
                return response.json();
            };
            return (cartHost ? cartHost.queueMutation(save) : save())
            .then(() => {
                if(this.isConnected && this.status && this.textarea.value === note){
                    this.status.setAttribute('data-hidden', 'false');
                    syncCartAccordionHeight(this);
                    clearTimeout(this.statusTimer);
                    this.statusTimer = setTimeout(() => {
                        this.status.setAttribute('data-hidden', 'true');
                        syncCartAccordionHeight(this);
                    }, 2000);
                }
            })
            .catch(e => console.error(e));
        }
    }

    customElements.define('cart-note', CartNote);
}

if(!customElements.get('cart-gift-wrapping')){
    class CartGiftWrapping extends HTMLElement {
        constructor(){
            super();
        }

        connectedCallback(){
            this.checkbox = this.querySelector('input[type="checkbox"]');
            // Both cart hosts expose the same mutation queue and loading state.
            this.cartHost = this.closest('cart-drawer') || this.closest('custom-cart');
            if(this.checkbox){
                this.checkbox.addEventListener('change', this.toggleGiftWrapping.bind(this));
            }
        }

        toggleGiftWrapping(){
            const variantId = this.dataset.variantId;
            const cartHost = this.cartHost;
            if(!variantId || !cartHost) return;

            const checked = this.checkbox.checked;
            this.checkbox.setAttribute('disabled', '');
            // Quantity edits still refer to the current line order. Commit them
            // before adding/removing wrapping, then render before the next task.
            cartHost.flushPendingQuantityUpdates();
            cartHost.setLoading(true);
            const controls = cartHost.querySelectorAll('.sidebar__cart-items, .sidebar__cart-footer, :scope > .custom-container');
            const previousInert = Array.from(controls, element => element.inert);
            controls.forEach(element => element.inert = true);
            let updated = false;

            return cartHost.queueMutation(async () => {
                const config = fetchConfig();
                config.signal = cartHost.requestSignal();
                const body = checked ? { id: variantId, quantity: 1 } : { updates: { [variantId]: 0 } };
                body.sections = [cartHost.sectionId, 'header-cart-icon'];
                body.sections_url = window.location.pathname;
                config.body = JSON.stringify(body);

                const response = await fetch(checked ? routes.cart_add_url : routes.cart_update_url, config);
                const result = await response.json();
                if(!response.ok || result.status) throw new Error(result.description || result.message || 'Unable to update gift wrapping.');
                updated = true;

                let sections = result.sections;
                if(!sections || !sections[cartHost.sectionId] || !sections['header-cart-icon']){
                    const refresh = await fetch(`${window.location.pathname}?sections=${body.sections.join(',')}`, { signal: cartHost.requestSignal() });
                    if(!refresh.ok) throw new Error('Unable to refresh the cart.');
                    sections = await refresh.json();
                }
                if(!sections[cartHost.sectionId]) throw new Error('Unable to refresh the cart.');
                const renderSection = cartHost.renderDrawerSection || cartHost.renderCartSection;
                renderSection.call(cartHost, sections[cartHost.sectionId]);
                if(sections['header-cart-icon']) cartHost.updateCartCount(sections['header-cart-icon']);
            })
            .catch(e => {
                console.error(e);
                if(!updated) this.checkbox.checked = !checked;
            })
            .finally(() => {
                this.checkbox.removeAttribute('disabled');
                controls.forEach((element, index) => element.inert = previousInert[index]);
                cartHost.setLoading(false);
            });
        }
    }

    customElements.define('cart-gift-wrapping', CartGiftWrapping);
}
